export function getHashObject(){
    var hashSplit = location.hash.split('&');
    var hashObj = {};
    for(var i in hashSplit){
        hashSplit[i] = hashSplit[i].replace('#',"");
        var tmp = hashSplit[i].split('=');
        if(tmp && tmp.length > 1){
            hashObj[tmp[0]] = tmp[1];
        }
    }
    return hashObj;
}

export function getHashValue(key, notFoundVal){
    notFoundVal = (typeof(arguments[1])!="undefined")?arguments[1]:false;
    var hashValues = getHashObject();
    if(typeof(hashValues[key]) != "undefined"){
        return hashValues[key];
    }
    return notFoundVal;
}

export function setHashValues(keyValue){
    var newHashArray = $.extend({},getHashObject(),keyValue);
    var hashString = getHashStrFromObject(newHashArray);
    window.history.pushState(hashString,'',location.pathname+location.search+'#'+hashString);
}

export function getHashStrFromObject(keyValue){
    var result = '';
    for(var key in keyValue){
        var tmp = key + "=" + keyValue[key];
        if(result != "") tmp = "&"+tmp;
        result += tmp;
    }
    return result;
}

$(document).on('page.dt length.dt','table',function(e,settings){
    var hashNew = {};
    var hashKey = $(this).attr('id')+"_page";
    var value = $(this).DataTable().page()+"_"+settings._iDisplayLength;
    hashNew[hashKey] = value;
    setHashValues(hashNew)
});

export function dtGetPgData(tableId){
    var hashKey = tableId+"_page";
    var page = getHashValue(hashKey,false);
    if(page == false) return [0,50];
    var data=page.split("_");
    if(typeof(data[1])=="undefined")data[1]=50;
    return data;
}

export function dtCalculateDisplayStart(tableId){
    var data = dtGetPgData(tableId);
    return data[0]*data[1];
}

export function dtCalculateDisplayLength(tableId){
    var data = dtGetPgData(tableId);
    return data[1];
}

